import CommingSoon from "./CommingSoon";

export default CommingSoon;